import 'react-app-polyfill/ie11';
import 'core-js/stable';
//import React from   'react';
import axios from 'axios';
import { getCookie } from '../util/cookieActions';
import qs from 'qs'
// import config from "../config.json";
// import config from "../../public/config.json";
import CryptoJS from 'crypto-js';

export const getToken = async () => {
  let res;
  if(window.config.isNewTokenStrategy){
    let devCookie = getCookie(window.config.businessUnit + '-dcaDevCookie');
    res = await axios.post(window.config["gatewayUrl"]+"ui/directlinetoken?code="+window.config["d4e13c296cf1fd10beca8bfa4e804bc4"]?.split("&=")[1],
      { "businessUnit": window.config.businessUnit, "isAEM": window.config.isAEM ? true : false,"isChina":window.config.isChina,"isFAQ2.0":window.config.isFAQ2 ,"isDev":devCookie?true:false},
      {
        headers:
          {'Content-Type': 'application/json' }
    });
    console.log(res,"..res")
  }
  return res;
}
export const fileToBase64=(file)=>{
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const base64 = String(r.result).split(',')[1] || '';
      resolve(base64);
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
export const  sendToUploadAPI=async({ file, caseId, apiUrl })=>{
  const VersionData = await fileToBase64(file);
  const payload = {
    Title: file.name,
    PathOnClient: file.name,
    FirstPublishLocationId: caseId,
    VersionData
  };

  const res = await fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.success === false) {
    let normalizedCode = 'system';
    let displayMessage = 'Please try again.';

// SIZE ERROR
if (data?.message?.toLowerCase().includes("size")) {
    normalizedCode = "size";
    displayMessage = "File size exceeds the maximum allowed limit of 4 MB.";
}

// TYPE ERROR
else if (data?.message?.toLowerCase().includes("type")) {
    normalizedCode = "type";
    displayMessage = "File type not supported. Please upload a valid file type.";
}
// RETURN CLEAN STRUCTURE
return {
    ok: false,
    code: normalizedCode,
    message: displayMessage
};
  }

  return { ok: true, id: data?.data?.id };
}

export const sendPrivacyNotAccepted = async () => {
  if (!window.config.isChina) {
    let res;
    res = await axios.post(window.config["gatewayUrl"] + "ui/privacyfunction",
      {
        pageUrl: localStorage.getItem("pageUrl"),
        value: new Date(),
        sbg: window.config.sbg,
        gbe: window.config.gbe,
      },
      {
        headers:
          { 
            'Content-Type': 'application/json',
            'x-api-key':window.config["f3a7b1c4e8d2a0b1c6e9f8a4d7c2e1f5"]?.split("&=")[1]
          }
      });
    //console.log(res, "..res")
    return res;
  }
  else {
    return null;
  }
}


export const getRefreshToken = async () => {
  const res = await axios.post('https://directline.botframework.com/v3/directline/tokens/refresh', {}, { headers: { 'Authorization': `Bearer ${getCookie(window.config.businessUnit + '-Token')}`, 'Cache-Control': 'no-cache,no-store', 'Expires': 0, 'Pragma': 'no-cache' } });
  return res;
}


export const getSuggestedInput = async (searchValue, appInsights) => {
 
  const url =window.config["gatewayUrl"]+"ui/search?code="+window.config["d4e13c296cf1fd10beca8bfa4e804sear4ch"]?.split("&=")[1]
  
  const requestBody = {
    "suggesterName" : window.config["3349726563746c696e650e07c17c22c"].split("&=")[1],
    "indexName": window.config["5rte2b5d0a4f9dfe9f3b7a88c17c55r"].split("&=")[1],
    "apiVersion": window.config.apiVersion,
    "searchServiceName":window.config["5589726563746c696e650e07c17c55e"]?.split("&=")[1],
    "searchValue": searchValue,
    "businessUnit": window.config.businessUnit,
    "searchServiceAPiKey": (window.config.businessUnit === 'PMT-HPS' || window.config.businessUnit === 'SPS-ECOMM')?window.config.searchServiceApi.split("&=")[1]: window.config["7f3e2b5d0a4f9dfe9f3b7a88c17c66d"]?.split("&=")[1],
  };
  let encryptedData=requestBody;
  if(window.config.secretKey){
  encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(requestBody),
      window.config.secretKey
    ).toString();
  }
  try {
    const response = await axios.post(url, encryptedData, {
      headers:
        {'Content-Type': 'application/json' }
    });
    if (response.status !== 200) {
     // console.log('Unexpected response status:', response.status);
      return null; 
    }
    return response.data; //function will return value directly in body.
  } catch (error) {
    //console.log('error at autosuggestion:', error);

    if (error.response) {
      appInsights.trackTrace({ message: "Exceptions", properties: { name: "Suggested input error", message: error.message, stack: error.stack } });
      return null;
    };
  }
}